import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import {
	Button,
	Container,
	DataGrid,
	FlexGap,
	Heading3,
	Paragraph,
	Select,
	Separator,
	Skeleton,
	tokens,
} from '@treams/treams-ui';

const AnalyticsCard = styled(Box)`
	border: 1px solid ${tokens.border.subtle};
	border-radius: 5px;
	background-color: ${(props) => props.theme.colors.white};
	min-width: 0;
`;

const DoughnutSkeleton = styled(Skeleton.Box)`
	width: 80px;
	height: 80px;
	border-radius: 50%;
`;

export function CycleAnalyticsSkeleton() {
	return (
		<Container py={4} wide={true} minWidth={0}>
			<FlexGap mb={3} gap={tokens.gap.list} alignItems="stretch">
				<AnalyticsCard flex={1}>
					<Box p={3}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton lines={1} mt={2} />
						<Box mt={3} mx={3}>
							<Flex alignItems="center">
								<Flex mr={4} width={5 / 12} flexDirection="column" alignItems="center">
									<DoughnutSkeleton />
									<Paragraph.Skeleton lines={1} mt={2} width={140} />
								</Flex>
							</Flex>
						</Box>
					</Box>
				</AnalyticsCard>

				<AnalyticsCard flex={1}>
					<Box p={3}>
						<Heading3.Skeleton mb={2} />
						<Paragraph.Skeleton lines={1} mt={2} />
						<Paragraph.Skeleton lines={1} mt={2} />
					</Box>
				</AnalyticsCard>
			</FlexGap>

			<AnalyticsCard mb={3}>
				<Box p={3}>
					<Heading3.Skeleton />
				</Box>
				<DataGrid.Skeleton columns={5} rows={4} />
			</AnalyticsCard>

			<AnalyticsCard>
				<Box p={3}>
					<Heading3.Skeleton />
					<Flex mt={3}>
						<Select.Skeleton />
					</Flex>
				</Box>
				<DataGrid.Skeleton columns={6} rows={6} />
				<Box pb={3}>
					<Separator />
					<Flex mt={3} mx={3}>
						<Button.Skeleton />
					</Flex>
				</Box>
			</AnalyticsCard>
		</Container>
	);
}
